import { render, staticRenderFns } from "./SocialLanding.vue?vue&type=template&id=8cdeda9a&scoped=true&"
import script from "./SocialLanding.vue?vue&type=script&lang=js&"
export * from "./SocialLanding.vue?vue&type=script&lang=js&"
import style0 from "./SocialLanding.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SocialLanding.vue?vue&type=style&index=1&id=8cdeda9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdeda9a",
  null
  
)

/* custom blocks */
import block0 from "./SocialLanding.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./SocialLanding.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VCol,VContainer,VRow})
